import { render } from "./Survey.vue?vue&type=template&id=50876044"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"
script.render = render

export default script